import { createFileRoute } from '@tanstack/react-router';
import { CRMOpportunitiesPage } from '@/pages/CRM/Opportunities';

export const Route = createFileRoute('/_admin/crm/opportunities/')({
  component: CRMOpportunitiesPage,
});
